import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import FullPageLoader from "../components/FullPageLoader";
import { getWhichMenus } from "../components/Section";
import CornerLadybug from "../images/corner/corner-ladybug-art.webp";

const WINE_GROUP_ORDER = [
  "flights",
  "white",
  "sweet",
  "sparkling",
  "red",
  "fortified",
];

const WINE_GROUP_TITLES = {
  flights: "Flights",
  white: "Dry white and blush",
  sweet: "Sweet and fruit",
  sparkling: "Sparkling",
  red: "Dry red",
  fortified: "Fortified wines",
};

const formatLocationTitle = (type = "") =>
  type
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const SecondaryMenu = ({
  items,
  match: {
    params: { type },
  },
}) => {
  const locationTitle = formatLocationTitle(type);

  useEffect(() => {
    document.title = `Auburn Road - ${locationTitle} Menu`;
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, [locationTitle]);

  if (!items) {
    return <FullPageLoader />;
  }

  const wineTypeObj = {};
  items.forEach((item) => {
    if (!getWhichMenus(item).includes(type)) return;

    const secCat =
      item.secondary_category === "sweetFruit"
        ? "sweet"
        : item.secondary_category;
    if (!secCat) return;

    if (!wineTypeObj[secCat]) {
      wineTypeObj[secCat] = [];
    }
    wineTypeObj[secCat].push(item);
  });

  const orderedTypes = [
    ...WINE_GROUP_ORDER.filter((key) => wineTypeObj[key]?.length),
    ...Object.keys(wineTypeObj).filter(
      (key) => !WINE_GROUP_ORDER.includes(key) && wineTypeObj[key]?.length
    ),
  ];

  if (orderedTypes.length === 0) {
    return (
      <div className="container menu-page p-t-100 text-center">
        <section className="menu-hero secondary-menu-hero">
          <div>
            <p className="menu-hero__kicker">Wine list</p>
            <h1 className="huge-text-no-quote mb-3">Uh oh!</h1>
            <p className="menu-hero__intro">
              You've reached a page that doesn't exist.
            </p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <>
      <img className="corner-ladybug" src={CornerLadybug} alt="" />
      <div className="container menu-page secondary-menu-page p-t-100">
        <section className="menu-hero secondary-menu-hero">
          <div>
            <p className="menu-hero__kicker">Auburn Road Vineyards at</p>
            <h1 className="huge-text-no-quote mb-3">{locationTitle}</h1>
            <p className="menu-hero__intro">
              Bottle list available at this partner location.
            </p>
          </div>
        </section>

        <section className="menu-wine">
          <div className="menu-wine-groups">
            {orderedTypes.map((wineType, index) => (
              <div className="menu-wine-group" key={wineType}>
                <h3
                  className={`menu-wine-group__title menu-wine-group__title--${
                    index % 2 === 0 ? "swipe" : "swipe-2"
                  }`}
                >
                  {WINE_GROUP_TITLES[wineType] ||
                    wineType.charAt(0).toUpperCase() + wineType.slice(1)}
                </h3>
                <div className="menu-item-grid">
                  {wineTypeObj[wineType].map((item) => {
                    const price =
                      item.bottle_price ||
                      item.item_price ||
                      (item.glass_price ? `${item.glass_price} glass` : null);
                    return (
                      <article
                        className={`menu-item${
                          item.soldout ? " menu-item--soldout" : ""
                        }`}
                        key={item.id || item.Item_name}
                      >
                        <div className="menu-item__header">
                          <h3 className="menu-item__name">{item.Item_name}</h3>
                          <span className="menu-item__price">
                            {item.soldout ? "sold out" : price}
                          </span>
                        </div>
                        {item.small_description && (
                          <p className="menu-item__note">
                            {item.small_description}
                          </p>
                        )}
                        {item.long_description && (
                          <p className="menu-item__desc">
                            {item.long_description}
                          </p>
                        )}
                      </article>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default withRouter(SecondaryMenu);
